import React, { useState } from "react";
import ActionDropBar from "../../ActionDropBar/ActionDropBar";
import ToggleSwitch from "../../SwitchFile/ToggleSwitch";

const DataCard = ({
  index,
  title,
  array,
  handleup,
  handledown,
  handleStatus,
  setArray,
  children,
  color,
  activeDrop,
  setActiveDrop,
  active,
  slug
}) => {
  const onDelete = () => {
    let data = array.filter((item, dataindex) => dataindex != index);
    setArray(data);
  };

  const onCopy = () => {
    const copy = JSON.parse(JSON.stringify(array[index]));
    const data = [...array.slice(0, index + 1), copy, ...array.slice(index + 1)];
    setArray(data);
  };
const handleToggle = (val) => {
  const updatedArray = array.map((item, dataIndex) =>
    dataIndex === index ? { ...item, is_active: val ? 1 : 0 } : item
  );
  setArray(updatedArray);
};
  return (
    <div
      style={{
        background: color,
        border: "1px solid lightgray",
        marginBottom: "5px",
        boxShadow: `0 0 0 0 rgba(38, 143, 255, 0.5)`,
      }}
    >
      {" "}
      <ActionDropBar
        handleDelete={onDelete}
        handleCopy={onCopy}
        index={index}
        status={array[index]?.status ?? true}
        handleup={handleup}
        handledown={handledown}
        handleStatus={handleStatus}
        title={`  ${index + 1}. ${title}`}
        active={activeDrop == index}
        setActive={(active) =>
          active ? setActiveDrop(index) : setActiveDrop()
        }
        slug={slug}
      />
      {activeDrop == index && (
        <div style={{ marginTop: "10px" }}>{children}</div>
      )}
    </div>
  );
};

export default DataCard;
